/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ChangePasswordRequest,
  ConfirmPasswordRequest,
  GetCurrentUser200,
  GetUserSignupPartner200,
  HTTPValidationError,
  ProfileResponse,
  UpdateEmailRequest,
  UpdateProfileRequest,
} from './platformapi.schemas';

import changePasswordMutator from '../custom-axios-instance';
import confirmPasswordMutator from '../custom-axios-instance';
import getCurrentUserMutator from '../custom-axios-instance';
import getProfileMutator from '../custom-axios-instance';
import getUserSignupPartnerMutator from '../custom-axios-instance';
import updateEmailMutator from '../custom-axios-instance';
import updateProfileMutator from '../custom-axios-instance';

/**
 * Update password while signed in via cookie
 * @summary Change Password
 */
export const changePassword = (
  changePasswordRequest: ChangePasswordRequest,
  signal?: AbortSignal,
) => {
  return changePasswordMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/users/change-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: changePasswordRequest,
    signal,
  });
};

export const getChangePasswordMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePasswordRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationKey = ['changePassword'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: ChangePasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>;
export type ChangePasswordMutationBody = ChangePasswordRequest;
export type ChangePasswordMutationError = void | HTTPValidationError;

/**
 * @summary Change Password
 */
export const useChangePassword = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePassword>>,
      TError,
      { data: ChangePasswordRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationOptions = getChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Confirm password while signed in via cookie
 * @summary Confirm Password
 */
export const confirmPassword = (
  confirmPasswordRequest: ConfirmPasswordRequest,
  signal?: AbortSignal,
) => {
  return confirmPasswordMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/users/confirm-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: confirmPasswordRequest,
    signal,
  });
};

export const getConfirmPasswordMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPassword>>,
    TError,
    { data: ConfirmPasswordRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPassword>>,
  TError,
  { data: ConfirmPasswordRequest },
  TContext
> => {
  const mutationKey = ['confirmPassword'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPassword>>,
    { data: ConfirmPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return confirmPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPassword>>
>;
export type ConfirmPasswordMutationBody = ConfirmPasswordRequest;
export type ConfirmPasswordMutationError = void | HTTPValidationError;

/**
 * @summary Confirm Password
 */
export const useConfirmPassword = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmPassword>>,
      TError,
      { data: ConfirmPasswordRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmPassword>>,
  TError,
  { data: ConfirmPasswordRequest },
  TContext
> => {
  const mutationOptions = getConfirmPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves user data for the currently logged-in user on for the Dashboard
 * @summary Get Current User
 */
export const getCurrentUser = (signal?: AbortSignal) => {
  return getCurrentUserMutator<GetCurrentUser200>({
    url: `${import.meta.env['VITE_API_HOST']}/users/current`,
    method: 'GET',
    signal,
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/users/current`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) =>
    getCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>;
export type GetCurrentUserQueryError = void | HTTPValidationError;

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Current User
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the profile values of the currently logged-in user for editing
 * @summary Get Profile
 */
export const getProfile = (signal?: AbortSignal) => {
  return getProfileMutator<ProfileResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/users/profile`,
    method: 'GET',
    signal,
  });
};

export const getGetProfileQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/users/profile`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) =>
    getProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>;
export type GetProfileQueryError = void | HTTPValidationError;

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the impact partner and corporate client affiliations applied during signup
 * @summary Get User Signup Partner
 */
export const getUserSignupPartner = (signal?: AbortSignal) => {
  return getUserSignupPartnerMutator<GetUserSignupPartner200>({
    url: `${import.meta.env['VITE_API_HOST']}/users/signup-partner`,
    method: 'GET',
    signal,
  });
};

export const getGetUserSignupPartnerQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/users/signup-partner`] as const;
};

export const getGetUserSignupPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserSignupPartner>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSignupPartner>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserSignupPartnerQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSignupPartner>>> = ({ signal }) =>
    getUserSignupPartner(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSignupPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSignupPartnerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserSignupPartner>>
>;
export type GetUserSignupPartnerQueryError = void | HTTPValidationError;

export function useGetUserSignupPartner<
  TData = Awaited<ReturnType<typeof getUserSignupPartner>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserSignupPartner>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSignupPartner>>,
          TError,
          Awaited<ReturnType<typeof getUserSignupPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSignupPartner<
  TData = Awaited<ReturnType<typeof getUserSignupPartner>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserSignupPartner>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSignupPartner>>,
          TError,
          Awaited<ReturnType<typeof getUserSignupPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSignupPartner<
  TData = Awaited<ReturnType<typeof getUserSignupPartner>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserSignupPartner>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Signup Partner
 */

export function useGetUserSignupPartner<
  TData = Awaited<ReturnType<typeof getUserSignupPartner>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserSignupPartner>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserSignupPartnerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the email address of the currently logged-in user.
 * @summary Update Email
 */
export const updateEmail = (updateEmailRequest: UpdateEmailRequest, signal?: AbortSignal) => {
  return updateEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/users/update-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateEmailRequest,
    signal,
  });
};

export const getUpdateEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmail>>,
    TError,
    { data: UpdateEmailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmail>>,
  TError,
  { data: UpdateEmailRequest },
  TContext
> => {
  const mutationKey = ['updateEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmail>>,
    { data: UpdateEmailRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmail>>>;
export type UpdateEmailMutationBody = UpdateEmailRequest;
export type UpdateEmailMutationError = void | HTTPValidationError;

/**
 * @summary Update Email
 */
export const useUpdateEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmail>>,
      TError,
      { data: UpdateEmailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmail>>,
  TError,
  { data: UpdateEmailRequest },
  TContext
> => {
  const mutationOptions = getUpdateEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update the profile of the currently logged-in user.
 * @summary Update Profile
 */
export const updateProfile = (updateProfileRequest: UpdateProfileRequest, signal?: AbortSignal) => {
  return updateProfileMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/users/update-profile`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateProfileRequest,
    signal,
  });
};

export const getUpdateProfileMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: UpdateProfileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: UpdateProfileRequest },
  TContext
> => {
  const mutationKey = ['updateProfile'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { data: UpdateProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>;
export type UpdateProfileMutationBody = UpdateProfileRequest;
export type UpdateProfileMutationError = void | HTTPValidationError;

/**
 * @summary Update Profile
 */
export const useUpdateProfile = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProfile>>,
      TError,
      { data: UpdateProfileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: UpdateProfileRequest },
  TContext
> => {
  const mutationOptions = getUpdateProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
